const getKey = () => {
  const url = new URL(window.location.href);
  const path = url.pathname + url.search;
  return 'scroll-position[' + path + ']';
};
export const store = () => {
  // When the page is being unloaded store the scroll position.
  window.addEventListener('beforeunload', () => {
    sessionStorage.setItem(getKey(), window.scrollY);
  });
};
export const restore = () => {
  const key = getKey();

  // Get the scroll position from the session storage.
  let scrollY = sessionStorage.getItem(key);
  if (scrollY === null) {
    return;
  }
  scrollY = Number.parseFloat(scrollY);
  if (!scrollY) {
    return;
  }

  // Prevent the default browser behaviour.
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }
  // Scroll the user to the section.
  window.scrollTo({
    top: scrollY,
    left: 0,
    behavior: 'instant'
  });

  // Clear again so the user doesn't keep scrolling to this section again.
  sessionStorage.removeItem(key);
};